import TextStyle from '@rezdy/components/TextStyle';
import Link from '@rezdy/components/Link';
import React from 'react';
import { Trans } from 'react-i18next';
import { CONTACT_SUPPORT } from '../constants/auth';

export function ContactSupport() {
    return (
        <TextStyle as="p">
            <Trans>
                Need help?{' '}
                <Link href={CONTACT_SUPPORT} target="_blank">
                    Contact Support
                </Link>
            </Trans>
        </TextStyle>
    );
}
